import React, { useState, useCallback } from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import CustomerSearchInput from "../CustomerSearchInput";
import CustomersTableOasis from './CustomersTableOasis';

function CustomersTab() {
    const [tableSearch, setTableSearch] = useState({ type: null, value: "" });

    const updateSearchValue = useCallback((value, meta = { type: "query" }) => {
      if (!value) {
        setTableSearch({ type: null, value: "" });
        return;
      }
      setTableSearch({
        type: meta.type === "customerId" ? "customerId" : "query",
        value: String(value),
      });
    }, []);

  return (
    <div>
      <Container maxWidth={false}>
        {/* <Grid container alignItems="center" spacing={2} sx={{my: 3}}>
          <Grid item> */}

          {/* </Grid>
        </Grid> */}
        <CustomersTableOasis
          tableSearch={tableSearch}
          updateSearchValue={updateSearchValue}
        />
      </Container>
    </div>
  );
}

export default CustomersTab;
